/* eslint-disable no-unused-vars */

import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../../../Axios/AxiosBaseQuery';
const URL = 'intern-service/profile/projects-past-experience';

// Create the API using createApi
export const GetPastExpApi = createApi({
  reducerPath: 'GetPastExpApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['past-exp'],
  staleTime: 1,
  endpoints: (builder) => ({
    getPastExp: builder.query({
      query: () => ({ url: URL, method: 'GET' }),
      providesTags: ['past-exp'],
    }),
    updateWorkEx: builder.mutation({
      query: (body) => ({
        url: 'intern-service/profile/projects-past-experience/save-work-experience',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['past-exp'],
    }),
    updateVolunteer: builder.mutation({
      query: (body) => ({
        url: 'intern-service/profile/projects-past-experience/save-volunteer',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['past-exp'],
    }),
    deleteWorkEx: builder.mutation({
      query: (id) => ({
        url: `intern-service/profile/projects-past-experience/work-experience/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['past-exp'],
    }),
    deleteVolunteer: builder.mutation({
      query: (id) => ({
        url: `intern-service/profile/projects-past-experience/volunteer/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['past-exp'],
    }),
  }),
});

// Export hooks for usage in components
export const {
  useGetPastExpQuery,
  useUpdateWorkExMutation,
  useUpdateVolunteerMutation,
  useDeleteWorkExMutation,
  useDeleteVolunteerMutation,
} = GetPastExpApi;
// Export the auto-generated hooks and reducer
export default GetPastExpApi.reducer;
